import api from "../api/axiosInstance";

const invoiceService = {
  getAll: (params) => api.get("/invoices", { params }),
  getOne: (id) => api.get(`/invoices/${id}`),
  create: (data) => api.post("/invoices", data),
  preview: (data) => api.post("/invoices/preview", data),
  update: (id, data) => api.patch(`/invoices/${id}`, data),
  delete: (id) => api.delete(`/invoices/${id}`),
  resend: (id) => api.post(`/invoices/${id}/resend`),
  render: (id) => api.get(`/invoices/${id}/render`),
  // The exact same pdfkit-generated PDF attached to the "invoice issued"
  // email — used for the print/download page so what's shown/downloaded
  // there always matches what was emailed.
  getPdf: (id) => api.get(`/invoices/${id}/pdf`, { responseType: "blob" }),
  pay: (id, data) => api.post(`/invoices/${id}/pay`, data),
  // Admin-only — pays off the FULL remaining balance on every selected
  // invoice, no proof required. `data` may carry { method, notes }.
  bulkMarkPaid: (invoiceIds, data) => api.post("/invoices/bulk-mark-paid", { invoiceIds, ...data }),
  getPaymentProofUploadUrl: (id, file) =>
    api.post(`/invoices/${id}/payment-proof-upload-url`, { name: file.name, type: file.type, size: file.size }),
  submitPayment: (id, data) => api.post(`/invoices/${id}/submit-payment`, data),
  getPaymentProofUrl: (id) => api.get(`/invoices/${id}/payment-proof`),
  approvePayment: (id) => api.post(`/invoices/${id}/approve-payment`),
  rejectPayment: (id, reason) => api.post(`/invoices/${id}/reject-payment`, { reason }),
  getPayments: () => api.get("/invoices/payments"),
  getSummary: () => api.get("/invoices/summary"),
  calculateCharges: (shipmentId, params) =>
    api.get(`/invoices/calculate/${shipmentId}`, { params }),
  calculateItemsCharges: (data) => api.post("/invoices/calculate-items", data),
  getInvoiceableShipments: (params) =>
    api.get("/invoices/invoiceable-shipments", { params }),
  getOutstanding: (params) => api.get("/invoices/outstanding", { params }),
};

export default invoiceService;
